<small class="debug">{{me}}</small>
<div class="playlist_properties">
    <form [formGroup]="group" floatLabel="never">
        <app-table-list-input matInput required
                              (update)="onTableUpdate($event)"
                              [callBackValue]="onCallBackValue()"
                              [keepTableIds]="false"
                              [cloneVals]="true"
                              [confirmRemove]="false"
                              [disableDrag]="true"
                              [inputEditFormat]="{url: 'text', className: 'text', params: 'text'}"
                              [inputEditRenamePath]="[{path: '$.url', key: 'url'}, {path: '$.className', key: 'className'}, {path: '$.params', key: 'params'}]"
                              [tableColumns]="tableColumns"
                              [buttonBarClassName]="'scriptTableControl'"
                              [multiSelect]="false"
                              [rememberSelection]="false"
                              [allowFilter]="false"
                              [buttons]="tableButtons"
                              [formControlName]="'scriptTableControl'">
        </app-table-list-input>
    </form>
</div>
